import { AfterViewInit, Component, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { HomeOneComponent } from '../home-one/home-one.component';
import { HomeTwoComponent } from '../home-two/home-two.component';
import { HomeThreeComponent } from '../home-three/home-three.component';
import { HomeFourComponent } from '../home-four/home-four.component';
import { HomeFiveComponent } from '../home-five/home-five.component';
import { HomeSixComponent } from '../home-six/home-six.component';
import { HomeSevenComponent } from '../home-seven/home-seven.component';
import { HomeEighthComponent } from '../home-eighth/home-eighth.component';
import { HomeNineComponent } from '../home-nine/home-nine.component';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-dynamic-template',
  templateUrl: './dynamic-template.component.html',
  styleUrl: './dynamic-template.component.css',
  standalone: true

})
export class DynamicTemplateComponent implements AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;

  private templateComponents: { [key: string]: any } = {
    'home-one': HomeOneComponent,
    'home-two': HomeTwoComponent,
    'home-three': HomeThreeComponent,
    'home-four': HomeFourComponent,
    'home-five': HomeFiveComponent,
    'home-six': HomeSixComponent,
    'home-seven': HomeSevenComponent,
    'home-eighth': HomeEighthComponent,
    'home-nine': HomeNineComponent
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngAfterViewInit(): void {
    if (!this.container) {
      console.error('ViewContainerRef is not initialized');
      this.router.navigate(['/not-found'], { queryParams: { error: 'container-not-found' } });
      return;
    }

    this.route.data.subscribe({
      next: (data) => {
        const templateId = data['templateId'];
        console.log('Resolved templateId:', templateId);
        if (templateId && this.templateComponents[templateId]) {
          this.container.clear();
          this.container.createComponent(this.templateComponents[templateId]);
        } else {
          console.error('Invalid or missing templateId:', templateId);
          this.router.navigate(['/not-found'], { queryParams: { error: 'invalid-template' } });
        }
      },
      error: (err) => {
        console.error('Error in route data subscription:', err);
        this.router.navigate(['/not-found'], { queryParams: { error: 'data-error' } });
      }
    });
  }
}